import React, { Component } from "react";
import axios from "axios";

export class Step1Student extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fullName: props.formData.fullName || "",
      email: props.formData.email || "",
      mobile: props.formData.mobile || "",
      college: props.formData.college || "",
      course: props.formData.course || "",
      year: props.formData.year || "",
      city: props.formData.city || "",

      attachment: props.formData.attachment || null,

      // Dynamic Course List
      courses: [],
      loadingCourses: true,

      error: "",
    };
  }

  componentDidMount() {
    this.loadCourses();
  }

  loadCourses = async () => {
    try {
      const response = await axios.post(
        "https://idealtechnoride.in/api/course"
      );

      this.setState({
        courses: Array.isArray(response.data)
          ? response.data
          : [],
        loadingCourses: false,
      });
    } catch (error) {
      console.error(error);

      this.setState({
        loadingCourses: false,
      });
    }
  };

  handleChange = (e) => {
    if (e.target.type === "file") {
      this.setState({
        attachment: e.target.files[0],
        error: "",
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
        error: "",
      });
    }
  };

    render() {
    const { courses, loadingCourses } = this.state;

    return (
      <div className="container py-4">

        <div className="card shadow border-0">

          <div className="card-header bg-success text-white">
            <h3 className="mb-0">
              Step 1 : Student Information
            </h3>
          </div>

          <div className="card-body">

            <div className="row">

              {/* Full Name */}

              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Full Name *
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="fullName"
                  value={this.state.fullName}
                  onChange={this.handleChange}
                  placeholder="Enter Full Name"
                />
              </div>

              {/* Email */}

              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Email Address *
                </label>

                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                  placeholder="Enter Email"
                />
              </div>

              {/* Mobile */}

              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Mobile Number *
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="mobile"
                  value={this.state.mobile}
                  onChange={this.handleChange}
                  placeholder="Enter Mobile Number"
                />
              </div>

              {/* College */}

              <div className="col-md-6 mb-3">
                <label className="form-label">
                  College Name *
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="college"
                  value={this.state.college}
                  onChange={this.handleChange}
                  placeholder="Enter College Name"
                />
              </div>

              {/* Course */}

              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Course *
                </label>

                <select
                  className="form-select"
                  name="course"
                  value={this.state.course}
                  onChange={this.handleChange}
                >
                  <option value="">
                    {loadingCourses
                      ? "Loading Courses..."
                      : "Select Course"}
                  </option>

                  {courses.map((course) => (
                    <option
                      key={course.course_id}
                      value={course.course_name}
                    >
                      {course.course_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Current Year */}

              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Current Year *
                </label>

                <select
                  className="form-select"
                  name="year"
                  value={this.state.year}
                  onChange={this.handleChange}
                >
                  <option value="">Select Year</option>
                  <option>1st Year</option>
                  <option>2nd Year</option>
                  <option>3rd Year</option>
                  <option>4th Year</option>
                  <option>Final Year</option>
                  <option>Pass Out</option>
                </select>
              </div>

              {/* City */}

              <div className="col-md-12 mb-3">
                <label className="form-label">
                  City *
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="city"
                  value={this.state.city}
                  onChange={this.handleChange}
                  placeholder="Enter City"
                />
              </div>

              {/* Attachment */}

              <div className="col-md-12 mb-3">

                <label className="form-label">
                  Upload Your College ID
                </label>

                <input
                  type="file"
                  className="form-control"
                  name="attachment"
                  onChange={this.handleChange}
                />

                {this.state.attachment && (
                  <small className="text-success">
                    Selected File : {this.state.attachment.name}
                  </small>
                )}

              </div>

            </div>

                        {this.state.error && (
              <div className="alert alert-danger">
                {this.state.error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                type="button"
                className="btn btn-success"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>

        </div>

      </div>
    );
  }
}

export default Step1Student;